import { ILead } from "../models/Lead";
import PriceFormat from "./priceFormat";

type CollectionOptionSource = {
  name: string;
  price: number;
};

const parseCalculationJsonCollectionOption = (
  calculationJson: string | null | undefined
): CollectionOptionSource | null => {
  if (!calculationJson || calculationJson === "" || calculationJson === "{}") return null;

  try {
    const raw = JSON.parse(calculationJson) as Record<string, unknown>;
    const option = raw.CollectionOption as Record<string, unknown> | undefined;
    if (!option?.Name || typeof option.Name !== "string" || option.Name.trim() === "") {
      return null;
    }

    const price =
      typeof option.Value === "number"
        ? option.Value
        : typeof option.value === "number"
          ? option.value
          : 0;

    return { name: option.Name, price };
  } catch {
    return null;
  }
};

export function getCollectionOption(lead: ILead): CollectionOptionSource | null {
  const name = lead.collectionOptionName?.trim();
  if (name) {
    return {
      name,
      price: lead.collectionOptionPrice ?? 0,
    };
  }

  if (lead.collectionOptionId) {
    return {
      name: "Collection option",
      price: lead.collectionOptionPrice ?? 0,
    };
  }

  return parseCalculationJsonCollectionOption(lead.calculationJson);
}

export function hasCollectionOption(lead: ILead): boolean {
  return getCollectionOption(lead) !== null;
}

export function formatCollectionOption(lead: ILead): string {
  const option = getCollectionOption(lead);
  if (!option) return "";

  if (option.price !== 0) {
    return `${option.name} (${PriceFormat(option.price)})`;
  }
  return option.name;
}

export function hasLegacyPaymentOption(lead: ILead): boolean {
  return lead.roadSidePayment || lead.fastPayment;
}

export function hasAnyPaymentOption(lead: ILead): boolean {
  return hasCollectionOption(lead) || hasLegacyPaymentOption(lead);
}
